var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgPowerBi = function SvgPowerBi(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 630 630"
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "power_bi_svg__a",
    x1: "50%",
    x2: "50%",
    y1: "0%",
    y2: "100%"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: "0%",
    stopColor: "#EBBB14"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "100%",
    stopColor: "#B25400"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "power_bi_svg__d",
    x1: "50%",
    x2: "50%",
    y1: "0%",
    y2: "100%"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: "0%",
    stopColor: "#F9E583"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "100%",
    stopColor: "#DE9800"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "power_bi_svg__e",
    x1: "50%",
    x2: "50%",
    y1: "0%",
    y2: "100%"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: "0%",
    stopColor: "#F9E68B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "100%",
    stopColor: "#F3CD32"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "power_bi_svg__b",
    width: "136.5%",
    height: "116.9%",
    x: "-9.1%",
    y: "-6.3%",
    filterUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("feOffset", {
    dx: 20,
    dy: 10,
    "in": "SourceAlpha",
    result: "shadowOffsetOuter1"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    "in": "shadowOffsetOuter1",
    result: "shadowBlurOuter1",
    stdDeviation: 10
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    "in": "shadowBlurOuter1",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.0530211976 0"
  })), /*#__PURE__*/React.createElement("path", {
    id: "power_bi_svg__c",
    d: "M346 604v26H153c-14.36 0-26-11.64-26-26V183c0-14.36 11.64-26 26-26h167c14.36 0 26 11.64 26 26z"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd",
    transform: "translate(77.5)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 219,
    height: 630,
    x: 256,
    fill: "url(#power_bi_svg__a)",
    rx: 26
  }), /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#power_bi_svg__c",
    fill: "#000",
    filter: "url(#power_bi_svg__b)"
  }), /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#power_bi_svg__c",
    fill: "url(#power_bi_svg__d)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#power_bi_svg__e)",
    d: "M219 604v26H26c-14.36 0-26-11.64-26-26V341c0-14.36 11.64-26 26-26h167c14.36 0 26 11.64 26 26z"
  }))));
};
export default SvgPowerBi;